module.exports = __webpack_public_path__ + "static/media/tipologia11.c6c7e0aa.png";